var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcon3(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 86,
    height: 86,
    viewBox: "0 0 86 86",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2804_2272)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 16,
    width: 46,
    height: 46,
    rx: 8,
    fill: "#D38E34"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M50.3009 34.9195V40.0695C50.3009 43.1495 48.5409 44.4695 45.9009 44.4695H37.1109C36.6609 44.4695 36.2309 44.4295 35.8309 44.3395C35.5809 44.2995 35.3409 44.2295 35.1209 44.1495C33.6209 43.5895 32.7109 42.2895 32.7109 40.0695V34.9195C32.7109 31.8395 34.4709 30.5195 37.1109 30.5195H45.9009C48.1409 30.5195 49.7509 31.4695 50.1809 33.6395C50.2509 34.0395 50.3009 34.4495 50.3009 34.9195Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.3001 37.9206V43.0706C53.3001 46.1506 51.5401 47.4706 48.9001 47.4706H40.1101C39.3701 47.4706 38.7001 47.3706 38.1201 47.1506C36.9301 46.7106 36.1201 45.8006 35.8301 44.3406C36.2301 44.4306 36.6601 44.4706 37.1101 44.4706H45.9001C48.5401 44.4706 50.3001 43.1506 50.3001 40.0706V34.9206C50.3001 34.4506 50.2601 34.0306 50.1801 33.6406C52.0801 34.0406 53.3001 35.3806 53.3001 37.9206Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.4994 40.1394C42.9574 40.1394 44.1394 38.9574 44.1394 37.4994C44.1394 36.0414 42.9574 34.8594 41.4994 34.8594C40.0414 34.8594 38.8594 36.0414 38.8594 37.4994C38.8594 38.9574 40.0414 40.1394 41.4994 40.1394Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.7793 35.25C35.3693 35.25 35.0293 35.59 35.0293 36V39C35.0293 39.41 35.3693 39.75 35.7793 39.75C36.1893 39.75 36.5293 39.41 36.5293 39V36C36.5293 35.59 36.1993 35.25 35.7793 35.25Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.2109 35.25C46.8009 35.25 46.4609 35.59 46.4609 36V39C46.4609 39.41 46.8009 39.75 47.2109 39.75C47.6209 39.75 47.9609 39.41 47.9609 39V36C47.9609 35.59 47.6309 35.25 47.2109 35.25Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2804_2272",
    x: 0,
    y: 0,
    width: 86,
    height: 86,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.176471 0 0 0 0 0.6 0 0 0 0 0.372549 0 0 0 0.19 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2804_2272"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2804_2272",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon3);
export default __webpack_public_path__ + "static/media/icon3.15120385aaf81baeca93107fb77fab31.svg";
export { ForwardRef as ReactComponent };